/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { Col, FormFeedback, Input } from 'reactstrap';
import classNames from 'classnames';
import { IoClose } from 'react-icons/io5';
import { BsCheck } from 'react-icons/bs';
import './style.module.scss';
import { BiImageAdd } from 'react-icons/bi';
import { AiFillDelete } from 'react-icons/ai';
import { uploadImage } from '../../../../../../../actions';

function FieldAnswerItem({
  input,
  placeholder,
  meta: { error, touched },
  isCheckTrue,
  onDelete,
}) {
  const { value } = input;
  const [loaded, setLoaded] = useState(true);

  const changeTrue = async () => {
    input.onChange({ ...value, isTrue: !value.isTrue });
  };

  const onChange = async (e) => {
    try {
      setLoaded(false);
      const file = e.target.files[0];
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        // toastr.error(I18n.t('Ошибка'), I18n.t('Неверный формат картинки'));
        setLoaded(true);
        return;
      }

      const data = await uploadImage({ file });
      if (data.uploadedImg) {
        input.onChange({ ...value, url: data.uploadedImg });
      }

      setLoaded(true);
    } catch (error) {
      setLoaded(true);
    }
  };

  return (
    <div className="FieldAnswerBlock">
      <div
        className={classNames('FieldAnswerItem', { isTrue: value.isTrue })}
      >
        {value.url && (
          <div className={'image'}>
            <div
              className={'icon'}
              onClick={() => {
                input.onChange({ ...value, url: '' });
              }}
            >
              <IoClose size="30" />
            </div>
            <img src={value.url} />
          </div>
        )}
        {!value.url && (
          <React.Fragment>
            <Input
              // {...input}
              type="textarea"
              value={value.text || ''}
              placeholder={placeholder}
              // height="200"
              onChange={(e) =>
                input.onChange({ ...value, text: e.target.value })
              }
            />
            <label className={'icon_add'}>
              <BiImageAdd size="30" />
              <Input
                type="file"
                style={{ display: 'none' }}
                onChange={onChange}
              />
            </label>
            
          </React.Fragment>
        )}
        {onDelete && <div className='delete_icon' onClick={onDelete}>
              <AiFillDelete size="17" color="white" />
            </div>}
        {isCheckTrue && (
          <div className={'answerTrue'} onClick={changeTrue}>
            <BsCheck size="20" color="white" />
          </div>
        )}
      </div>
      {touched && error && (
        <div className={'error_FieldAnswerItem'} onInvalid>
          {error}
        </div>
      )}
    </div>
  );
}

export default FieldAnswerItem;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/FieldAnswerItem/FieldAnswerItem.jsx